(function () {
    'use strict';

    angular.module('app').component('corporateDashboardMemberAppStatisticsComponent', {
        templateUrl: require('/App/corporate/views/dashboard/memberAppStatistics/memberAppStatistics.component.html'),
        controller: ['$uibModal', controller],
        controllerAs: 'vm',
        bindings: {
            statistic: '<'
        }
    });

    function controller($modal) {
        var vm = this;
        vm.loading = false;
    }
})();
